<template>
  <v-container
    style="max-width: 8in; background-color: transparent"
    class="ml-0"
    id="to_hit_cards_id"
    ref="easyPrint"
  >
    <div v-if="pages.length > 0" style="max-width: 8in">
      <div class="page ml-0" v-for="(pg, index1) in pages" :key="index1">
        {{ index1 }}
        <v-container>
          <v-row
            align-items:
            start
            style="width: 100%; height: 3.1in"
            class="justify-space-around"
            v-for="(row, index2) in rows"
            :key="index2"
          >
            <v-col
              class="dc_container"
              v-for="(col, index3) in cols"
              :key="index3"
            >
              <div
                class="dicecard d-flex flex-column justify-center align-center mt2"
              >
                <small>Beta FX&copy;</small>
                <small class="mb-4">3d6 Dicecard</small>

                <p style="font-size: 26px; font-weight: 800">
                  <img
                    src="../images/tohit_50.png"
                    style="height: 0.35in; width: auto"
                  /><span
                    style="position: relative; top: -6px"
                    :class="[
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .tohit == 18 ||
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .tohit == 3
                        ? rr.toString()
                        : '',
                    ]"
                    >:
                    {{
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1].tohit
                    }}
                  </span>
                </p>
                <p style="font-size: 26px; font-weight: 800">
                  <img
                    src="../images/noun-skill-shield-penetrate-2360219.svg"
                    style="height: 0.5in; width: auto; transform: scaleX(-1)"
                  />
                  <span
                    style="position: relative; top: -19px"
                    :class="[
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .penatrate == 18 ||
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .penatrate == 3
                        ? rr.toString()
                        : '',
                    ]"
                    >:
                    {{
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .penatrate
                    }}
                  </span>
                </p>
                <p style="font-size: 26px; font-weight: 800">
                  <img
                    src="../images/noun-damage-5458085.svg"
                    style="height: 0.4in; width: auto"
                  />
                  <span
                    style="position: relative; top: -14px"
                    :class="[
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .damage == 18 ||
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1]
                        .damage == 3
                        ? rr.toString()
                        : '',
                    ]"
                    >:
                    {{
                      all3x3d6Rolls[index1 * 9 + index2 * 3 + index3 + 1].damage
                    }}
                  </span>
                </p>
                <v-spacer></v-spacer>
                <small class="mr-1" style="width: 100%; text-align: right">{{
                  index1 * 9 + index2 * 3 + index3 + 1
                }}</small>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <!--//@*/*
    //    *BUS Dice Cars  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.red {
  color: red;
}
.page {
  width: 8in;
  height: 10in;
  border: 5px solid rgb(92, 145, 206);
  background-color: white !important;
}
.dc_container {
  width: 2in;
  height: 3in;
}
.dicecard {
  width: 2in;
  height: 3in;
  border: 3px solid rgb(0, 0, 0);
  background-color: whitesmoke;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "tohitcards",
  mixins: [bus_common],
  props: ["all3x3d6Rolls"],
  data() {
    return {
      rr: "red--text",
      cols: [],
      rows: [],
    };
  },
  computed: {
    pages() {
      //   this.mrbreakpoint("page");
      var page_cnt = [];
      for (let i = 0; i < this.all3x3d6Rolls.length; i += 12) {
        page_cnt.push(i);
      }
      //    this.mrbreakpoint(result);
      return page_cnt;
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },

    fillArrayInt(array, length) {
      for (let index = 0; index < length; index++) {
        array.push(index);
      }
      return array;
    },
    init() {
      this.rows = this.mno(this.fillArrayInt(this.rows, 3));
      this.cols = this.mno(this.fillArrayInt(this.cols, 3));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
